import { Link } from "react-router-dom";
import { ExternalLink, Mail, BookOpen, Shield, FileText } from "lucide-react";
import { useTranslation } from "react-i18next";

export function Footer() {
  const currentYear = new Date().getFullYear();
  const { t } = useTranslation();

  return (
    <footer className="bg-gradient-to-r from-[#004161] via-[#0f8f8c] to-[#004161] text-white py-4 border-t border-white/20 w-full fixed bottom-0 left-0 z-10">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row justify-between items-center gap-3">
          <div className="text-xs md:text-sm font-section text-center md:text-left text-white/90">
            {t('footer.copyright', { year: currentYear })}
          </div>
          
          <div className="hidden md:flex items-center gap-4 text-sm justify-center">
            <Link to="/courses" className="hover:text-white/80 hover:underline font-section text-white/90">
              {t('footer.courses')}
            </Link>
            <Link to="/certificates" className="hover:text-white/80 hover:underline font-section text-white/90">
              {t('footer.certificates')}
            </Link>
            <Link 
              to="/documentation" 
              className="hover:text-white/80 hover:underline flex items-center gap-1 font-section text-white/90"
            >
              <BookOpen className="h-3.5 w-3.5" />
              {t('footer.documentation')}
            </Link>
            <Link 
              to="/privacy-policy" 
              className="hover:text-white/80 hover:underline flex items-center gap-1 font-section text-white/90"
            >
              <Shield className="h-3.5 w-3.5" />
              {t('footer.privacyPolicy')}
            </Link>
            <Link 
              to="/terms-of-service" 
              className="hover:text-white/80 hover:underline flex items-center gap-1 font-section text-white/90"
            >
              <FileText className="h-3.5 w-3.5" />
              {t('footer.termsOfService')}
            </Link>
            <a 
              href="mailto:info@nwsisd.org" 
              className="hover:text-white/80 hover:underline flex items-center gap-1 font-section text-white/90"
            >
              <Mail className="h-3.5 w-3.5" />
              {t('footer.contact')}
            </a>
            <a 
              href="https://www.nwsisd.org" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="hover:text-white/80 hover:underline flex items-center gap-1 font-section text-white/90"
            >
              {t('footer.nwsisd')}
              <ExternalLink className="h-3 w-3" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
